const register = {
  loginCredentials: "Mga Kredensyal sa Pag-login", // translated 
  companyInformation: "Impormasyon ng Kumpanya", // translated 
  contactDetails: "Mga Detalye ng Pakikipag-ugnayan", // translated 
  businessName: "Pangalan ng Negosyo", // translated 
  businessAddress: "Address ng Negosyo", // translated 
  registrationCode: "Kodigo ng Pagpaparehistro", // translated 
  businessRegistrationNumber: "Numero ng Pagpaparehistro ng Negosyo", // translated 
  websiteUrl: "URL ng Website", // translated 
  mobilePhone: "Teleponong Selpon", // translated 
  regionStateProvince: "Rehiyon/Estado/Lalawigan", // translated 
  legalTitle: "Legal na Titulo", // translated 
  city: "Lungsod", // translated 
  postalCode: "Kodigo ng Postal", // translated 
  registrationSuccess: "Tagumpay sa Pagpaparehistro.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Mangyaring maghintay ng ilang sandali at ikaw ay ire-redirect sa home page.", // translated 
  usernameEmail: "Pangalan ng Gumagamit (Email)", // translated 
  password: "Password", // translated 
  verifyPassword: "I-verify ang Password", // translated 
  documents: "Mga Dokumento", // translated 
  termsAndConditionsSection: "Mga Tuntunin at Kundisyon", // translated 
  certificateOfIncorporation: "Sertipiko ng Pagsasama", // translated 
  acceptTermsAndConditions: "Tanggapin ang Mga Tuntunin at Kundisyon", // translated 
  country: "Bansa", // translated 
  brandName: "Pangalan ng Tatak", // translated 
  register: "Magrehistro", // translated 
  isRequired: "Kinakailangan", // translated 
  passwordMin8Chars: "Dapat mayroong kahit man lang 8 karakter", // translated 
  passwordRequiresDigit: "Dapat maglaman ng kahit isang digit", // translated 
  passwordRequiresLowercase: "Dapat maglaman ng kahit isang maliit na titik", // translated 
  passwordRequiresUppercase: "Dapat maglaman ng kahit isang malaking titik", // translated 
  passwordRequiresSpecialChar: 'Dapat maglaman ng kahit isang espesyal na karakter(!@#$%^&*(),.?":{}|<>)', // translated 
  uploadFile: "Mag-upload ng File", // translated 
  filename: "Pangalan ng file:", // translated 
  fileType: "Uri:", // translated 
  fileSize: "Sukat:", // translated 
  maxFileSize10Mb: "Pinakamataas: 10MB", // translated 
  supportedFileTypes: "Mga sinusuportahang uri ng file:", // translated 
  showPassword: "Ipakita ang password", // translated 
  hidePassword: "Itago ang password", // translated 
  notAvailable: "Wala", // translated 
  fileSizeInKb: "{{size}} KB", // translated 
  mobilePhonePlaceholder: "hal. +12025550123", // translated 
  websiteUrlPlaceholder: "http://www.example.com", // translated 
  loading: "Naglo-load...", // translated 
  uploadingDocument: "Ina-upload ang dokumento...", // translated 
  percentUploaded: "{{percent}}% na na-upload", // translated 
  registrationSuccessful: "Matagumpay ang pagpaparehistro.", // translated 
  failedToUploadDocument: "Nabigong i-upload ang dokumento.", // translated 
  fieldIsRequired: "{{field}} {{isRequired}}", // translated 
  fieldMinLength: "Ang {{field}} ay dapat na mas mahaba kaysa sa {{min}} na mga karakter", // translated 
  fieldMustBeValidEmail: "Dapat ay isang wastong email ang {{field}}", // translated 
  fieldPasswordMinLength: "Ang {{field}} ay dapat mayroong kahit man lang 8 karakter", // translated 
  fieldPasswordRequiresDigit: "Ang {{field}} ay dapat maglaman ng kahit isang digit", // translated 
  fieldPasswordRequiresLowercase: "Ang {{field}} ay dapat maglaman ng kahit isang maliit na titik", // translated 
  fieldPasswordRequiresUppercase: "Ang {{field}} ay dapat maglaman ng kahit isang malaking titik", // translated 
  fieldPasswordRequiresSpecialChar:
    'Ang {{field}} ay dapat maglaman ng kahit isang espesyal na karakter (!@#$%^&*(),.?":{}|<>)', // translated 
  passwordsDoNotMatch: "Hindi tumutugma ang {{field}} sa {{otherField}}", // translated 
  fieldBetweenLength: "Ang {{field}} ay dapat nasa pagitan ng {{min}} at {{max}} na mga karakter", // translated 
  postalCodeBetweenLength: "Ang {{field}} code ay dapat nasa pagitan ng {{min}} at {{max}} na mga karakter", // translated 
  invalidUrlFormat: "Hindi wastong format ng URL", // translated 
  invalidEmailFormat: "Hindi wastong format ng email", // translated 
  emailMustMatchUsername: "Dapat kapareho ng email ang username (email)", // translated 
  mobilePhoneIsRequired: "Kinakailangan ang cellphone", // translated 
  certificateFileTooLarge: "Masyadong malaki ang File ng Sertipiko", // translated 
  termsMustBeAccepted: "Dapat tanggapin ang mga Tuntunin at Kundisyon", // translated 
};


export default register;
